import type { UniDriver } from '@wix/unidriver-core';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export const liveRegionDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),
    /**
     * Checks whether the component found with the given data hook
     * @returns {Promise<boolean>}
     */
    exists: async () => base.exists(),

    /**
     * Gets the component root element
     * @returns {Promise<any>}
     */
    element: async () => base.getNative(),

    /**
     * Returns the message
     * @returns {Promise<string>}
     */
    getMessage: async () => base.text(),

    /**
     * Returns the role
     * @returns {Promise<string>}
     */
    getRole: async () => base.attr('role'),
  };
};

export type LiveRegionUniDriver = ReturnType<typeof liveRegionDriverFactory>;
